
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import VueSelect from "vue-select";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table3.vue";
import { Money } from "v-money";
import { priceOptions, SistemaMixin } from "@/modules/Application";

export default {
  name: "app-lista-preco-servico-form",
  components: {
    VueSelect,
    TrashCanIcon,
    TableApp,
    Money,
  },
  mixins: [validationMixin, SistemaMixin],
  props: {
    url: {
      type: String,
      required: true,
    },
    lista: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      priceOptions,
      form: {
        descricao: null,
        status: true,
      },
      servicoSelected: null,
      precoLista: 0,
      servicosFetched: [],
      servicos: [],
      keyToRender: 0,
      fields: [
        {
          label: "Serviço",
          field: "discriminacao",
          slot: true,
          sortable: false,
          width: "60%",
          filterOptions: { enabled: false },
        },
        {
          label: "Preço",
          field: "preco_lista",
          slot: true,
          sortable: false,
          width: "25%",
          filterOptions: { enabled: false },
        },
        {
          label: "",
          field: "actions",
          slot: true,
          sortable: false,
          width: "15%",
          filterOptions: { enabled: false },
        },
      ],
    };
  },
  validations: {
    form: {
      descricao: { required },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSearchServico(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchServicos(loading, search, this);
      }
    },
    searchServicos: _.debounce(async (loading, search, vm) => {
      try {
        const { data } = await vm.$http.post("/servicos/filter", {
          discriminacao: search,
        });
        vm.servicosFetched = [...data];
      } finally {
        loading(false);
      }
    }, 350),
    setServico(servico) {
      this.precoLista = servico ? Number(servico.valor || 0) : 0;
    },
    addServico() {
      if (!this.servicoSelected || Number(this.precoLista) <= 0) {
        this.$toast.error("Selecione um serviço e informe um preço válido!");
        return;
      }

      if (
        this.servicos.some(
          (servico) => servico.id_servico === this.servicoSelected.id_servico
        )
      ) {
        this.$toast.error("Este serviço já está na lista!");
        return;
      }

      this.servicos.push({
        ...this.servicoSelected,
        preco_lista: Number(this.precoLista),
      });
      this.servicoSelected = null;
      this.precoLista = 0;
      this.keyToRender += 1;
    },
    removerServico(idServico) {
      this.servicos = this.servicos.filter(
        (servico) => servico.id_servico !== idServico
      );
      this.keyToRender += 1;
    },
    async salvarLista() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        this.$toast.error(
          "Verifique todos os campos obrigatórios do formulário!"
        );
        return;
      }

      if (this.servicos.length === 0) {
        this.$toast.error("Insira ao menos um serviço na lista!");
        return;
      }

      this.addLoadingToButton("submit_lista_preco_servico");
      try {
        await this.$http.post(this.url, {
          ...this.form,
          servicos: this.servicos.map(
            ({ id_servico, discriminacao, preco_lista }) => ({
              id_servico,
              discriminacao,
              preco_lista,
            })
          ),
          ...(this.lista.id_lista_preco_servico && {
            id_lista_preco_servico: this.lista.id_lista_preco_servico,
          }),
        });
        this.$router.push({ name: "listaPrecosServicos" });
      } finally {
        this.removeLoadingToButton("submit_lista_preco_servico");
      }
    },
    preencherLista(lista) {
      if (!lista || !lista.id_lista_preco_servico) return;

      this.form.descricao = lista.descricao;
      this.form.status = lista.status;
      this.servicos = (lista.servicos || []).map((servico) => ({
        ...servico,
        preco_lista: servico.pivot.preco_lista,
      }));
      this.keyToRender += 1;
    },
  },
  watch: {
    lista: {
      immediate: true,
      handler(value) {
        this.preencherLista(value);
      },
    },
  },
};
